import React from 'react'
import { IconSolidInfo } from '@notino/react-styleguide'
import * as SC from './BasicSalonStyles'
import { ConfigResponse, SalonDetail } from '../../../../types/types'
import SalonContacts from '../SalonContacts/SalonContacts'
import useMessages from '../../../../hooks/useMessages'
import SalonMapEmbed from '../../../../components/SalonMapEmbed/SalonMapEmbed'

type Props = {
	salonData: SalonDetail
	countriesData: ConfigResponse['rolloutCountries']
}

const BasicSalon = (props: Props) => {
	const { salonData, countriesData } = props
	const { messages } = useMessages()

	const linkFromTranslations = messages['notino-partner-link']
	const FALLBACK_LINK = 'https://partner.notino.cz/#jak-na-to'
	const link = !linkFromTranslations || linkFromTranslations === '_NEPRELOZENE_' ? FALLBACK_LINK : linkFromTranslations

	const partnerLink = (
		<SC.NotinoPartnerLinkContainer>
			<IconSolidInfo color={'icon.primary'} width='16' />
			<SC.NotinoPartnerLink href={link} target='_blank' rel={'noopener noreferrer'}>
				{messages['Is this your salon?']}
			</SC.NotinoPartnerLink>
		</SC.NotinoPartnerLinkContainer>
	)

	const lng = salonData.address?.longitude
	const lat = salonData.address?.latitude

	return (
		<div>
			{salonData.name && <SC.Heading>{salonData.name}</SC.Heading>}

			<SC.BasicSalonLayout>
				<SC.MapColumn>
					<SC.MapContainer id={'google-map'}>
						<SalonMapEmbed lat={lat} lng={lng} formattedAddress={salonData.formattedAddress} salonName={salonData.name} />
					</SC.MapContainer>
				</SC.MapColumn>
				<SC.ContactsColumn>
					<SalonContacts salonData={salonData} countriesData={countriesData} />
					{partnerLink}
				</SC.ContactsColumn>
			</SC.BasicSalonLayout>
		</div>
	)
}

export default BasicSalon
